import { createSlice } from "@reduxjs/toolkit";
import { getAllAiCampaignsAPI } from "../../services/getAllAiCampaigns";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAllAiCampaignsSlice = createSlice({
  name: "getAllAiCampaigns",
  initialState: data,
  reducers: {
    getAllAiCampaignsInfo(state) {
      state.isLoading = true;
    },
    getAllAiCampaignsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getAllAiCampaignsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getAllAiCampaignsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAllAiCampaignsHandler = (payload) => async (dispatch) => {
  try {
	  dispatch(getAllAiCampaignsAction.getAllAiCampaignsInfo());
	  const response = await getAllAiCampaignsAPI(payload);
    dispatch(getAllAiCampaignsAction.getAllAiCampaignsInfoSuccess(response));
  } catch (e) {
    const errorMessage =
      typeof e === "string"
        ? e
        : e?.response?.data?.message || e?.message || "Something went wrong.";

    dispatch(
      getAllAiCampaignsAction.getAllAiCampaignsInfoFailure(errorMessage),
    );
  }
};

export default getAllAiCampaignsSlice.reducer;
export const getAllAiCampaignsAction = getAllAiCampaignsSlice.actions;

